export default __webpack_public_path__ + "static/media/fonts/alegreyasans-black-webfont.741323f9.woff";